import generateUtilityClass from '../../utils/esm/generateUtilityClass/generateUtilityClass.esm.js';
import generateUtilityClasses from '../../utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js';

function getFormControlUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControl', slot);
}
generateUtilityClasses('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);

export { getFormControlUtilityClasses };
